<template>
  <div class="py-5 container-fluid">
    <div id="topinfo">
      <div class="row mt-4 justify-content-center">
        <div class="col-12">
          <div class="mx-auto col-11 d-flex mb-2 flex-column card card-body blur shadow-blur">
            <div class="card-header mb-0 text-center">
              <h3 class="font-weight-bolder text-success text-gradient">Measure Diameters</h3>
              <h5
                v-if="coating_booth"
                class="mb-0"
              >
                for Line <i>{{ coating_booth.name }}</i>
              </h5>
            </div>
          </div>
          <div class="mx-auto col-11 d-flex mb-2 flex-column card card-body blur shadow-blur">
            <HopperSelector
              v-if="isMichiganRegionUser === false"
              v-model:selected_hopper="selected_hopper"
              :hoppers="hoppers"
              :lock_dropdown="lock_dropdown"
              @update:selected_hopper="handleHopperSelection()"
            />
            <div
              v-if="selected_hopper !== null"
              class="card-header row"
            >
              <div>
                <div
                  class="card-body"
                  style="padding-top: 0.2rem"
                >
                  <LineLayoutVisualization
                    v-if="showLineLayoutVisualization"
                    :coating-booth="coating_booth"
                  />
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5 class="text-start mb-1">Venturi Diameters</h5>
                  </div>
                  <!-- UNCOMMENT FOR TESTING PURPOSES ONLY
                  <div class="d-flex justify-content-between">
                    <button
                      type="button"
                      class="btn btn-light btn-sm"
                      @click="populateWithLastVenturiDiameters"
                    >
                      Auto-fill with Latest Diameter Measures
                      <i
                        class="fa fa-info-circle"
                        title="Automatically fill form with the diameters from the most recent bagging or diameter measures"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-container="body"
                        data-animation="true"
                      ></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-light btn-sm"
                      @click="clearVenturiDiameters"
                    >
                      Clear all diameters
                    </button>
                  </div> -->
                  <div style="overflow-x: auto">
                    <div class="table-responsive">
                      <table
                        class="table table-sm text-center"
                        style="border-width: 0 !important"
                      >
                        <thead>
                          <tr>
                            <th>Gun Name</th>
                            <th>Diameter</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="gun in gun_data"
                            :key="gun.gun_index"
                            :class="getValidationClass(gun.gun_index)"
                          >
                            <td>
                              <div>
                                <p>
                                  {{ gun.gun_name }}
                                  <i
                                    v-if="!gun.current_gun_status.is_latest_bagging_valid"
                                    title="Last Bagging for this gun Failed. Please retake the bagging"
                                    class="fa fa-info-circle"
                                    aria-hidden="true"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    data-container="body"
                                    data-animation="true"
                                  >
                                  </i>
                                </p>
                              </div>
                            </td>
                            <td>
                              <div v-if="!gun.current_gun_status.is_latest_bagging_valid">
                                <p>-</p>
                              </div>
                              <div
                                v-else-if="
                                  gun.validation_status === 'valid' ||
                                  gun.validation_status === 'rejected' ||
                                  gun.validation_status === 'pending_change_venturi'
                                "
                              >
                                <p>{{ gun.venturi_diameter }}</p>
                              </div>
                              <div v-else>
                                <input
                                  v-model.lazy="gun.venturi_diameter"
                                  type="number"
                                  class="form-control form-control-sm mx-auto text-center"
                                  min="0"
                                  :placeholder="`Diameter [${$store.state.units_system.metric.distance_minor}] `"
                                  style="max-width: 190px"
                                  @blur="
                                    diameterWithinRangeCheck($event.target.value, gun);
                                    saveFormProgress();
                                  "
                                  @keydown="numericPositiveOnly"
                                  @change="is_calculation_completed = false"
                                />
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div
                    v-if="!allGunsEvaluated"
                    class="col-12 text-center mt-4 mb-4"
                  >
                    <button
                      type="button"
                      class="mt-4 mb-2 text-center btn"
                      :class="emptyVenturiDiametersMeasurements ? 'bg-gradient-secondary' : 'bg-gradient-success'"
                      style="width: 90%"
                      @click="getResultsFromDiameterMeasurements()"
                    >
                      Update Venturi Diameters
                    </button>
                  </div>
                  <div
                    v-if="venturiDiametersUpdated"
                    class="col-12 text-center mt-4 mb-4"
                  >
                    <div class="color-legend mb-3">
                      <div class="legend-item">
                        <span class="color-box valid-row"></span>
                        <span>Valid</span>
                      </div>
                      <div class="legend-item">
                        <span class="color-box accepted-row"></span>
                        <span>Change Venturi</span>
                      </div>
                      <div class="legend-item">
                        <span class="color-box rejected-row"></span>
                        <span>Service</span>
                      </div>
                    </div>
                    <div class="col-lg-12 text-center">
                      <h5 class="">Powder Output Chart</h5>
                      <steel-case-guns-equalization-chart
                        :datasets="guns_equalization_datasets"
                        :recipes="gun_data[0].recipes"
                      />
                    </div>
                    <div
                      v-if="allGunsEvaluated"
                      class="col-12 text-center justify-content-center mt-4"
                    >
                      <soft-button
                        type="button"
                        class="mb-0 ms-auto js-btn-next"
                        style="width: 70%; min-width: 160px; max-width: 500px"
                        :disabled="!venturiDiametersUpdated"
                        @click="measureDiametersFinished()"
                      >
                        Finish Update Process &nbsp; &nbsp;
                      </soft-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mx-auto col-11 d-flex mb-2 flex-column card card-body blur shadow-blur">
            <div class="accordion">
              <div class="accordion-item mb-0">
                <h5>
                  <button
                    class="accordion-button collapsed mb-0 p-2"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseParams"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseParams"
                    style="padding: 0"
                  >
                    <p
                      class="font-weight-bolder mt-1"
                      style="font-weight: 700 !important; font-size: 1.05rem; vertical-align: middle; margin-bottom: 0"
                    >
                      Measure Diameters History
                      <i
                        class="fa fa-chevron-down"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-chevron-up"
                        aria-hidden="true"
                      ></i>
                    </p>
                  </button>
                </h5>
                <div
                  id="panelsStayOpen-collapseParams"
                  class="accordion-collapse collapse"
                  aria-labelledby="panelsStayOpen-headingOne"
                >
                  <div
                    class="accordion-body"
                    style="padding: 0"
                  >
                    <div
                      v-if="previous_measurements.length > 0"
                      style="overflow-x: auto"
                    >
                      <table
                        class="table table-bordered table-sm mt-3"
                        style="min-width: 600px"
                      >
                        <thead>
                          <tr style="background-color: #f0f0f0">
                            <th><b>Date</b></th>
                            <th><b>Hopper</b></th>
                            <th
                              v-for="gun in gun_data"
                              :key="gun.gun_id"
                            >
                              <b>Gun {{ gun.gun_name }}</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="measurement in previous_measurements"
                            :key="measurement.id"
                          >
                            <td
                              :class="['text-dark', { 'hovered-row': hovered_measurement === measurement.id }]"
                              style="cursor: pointer"
                              data-bs-toggle="modal"
                              data-bs-target="#modal-form"
                              @click="showGunDetailModal(measurement)"
                              @mouseover="hovered_measurement = measurement.id"
                              @mouseleave="hovered_measurement = null"
                            >
                              {{ measurement.created_at }}
                            </td>
                            <td class="text-secondary">{{ measurement.hopper.name }}</td>
                            <td
                              v-for="gun in gun_data"
                              :key="gun.gun_id"
                              :style="{
                                backgroundColor: getVenturiColorFromDiameter(
                                  measurement.inference[gun.gun_id]
                                    ? measurement.inference[gun.gun_id].venturi_diameter
                                    : null,
                                ),
                              }"
                            >
                              <span>{{
                                measurement.inference[gun.gun_id]
                                  ? measurement.inference[gun.gun_id].venturi_diameter
                                  : "-"
                              }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <DiameterMeasurementGunReviewModal
            v-if="
              (!change_venturi_guns_evaluated || !maintenance_needed_guns_evaluated) &&
              currentGunForReview.validation_status !== null
            "
            :gun-name="currentGunForReview.gun_name"
            :gun-review-index="gun_review_index"
            :validation-status="currentGunForReview.validation_status"
            :gun-dataset="getGunRegressionDataset(currentGunForReview.gun_name)"
            :gun-recipes="getGunRecipes(currentGunForReview)"
            :total-number-of-guns="totalNumberOfGunsToEvaluate"
            :pending-guns-to-evaluate="gunsPendingToEvaluate"
            @nextgunreview="nextGunReview"
            @previousgunreview="previousGunReview"
            @updategunvalidationstatus="currentGunForReview.validation_status = $event"
            @donereviewingfailedguns="doneReviewingFailedGuns"
            @donereviewingchangeventuriguns="doneReviewingChangeVenturiGuns"
          />
          <RecipesReviewModal
            v-if="visualize_recipes && updated_recipes.length > 0"
            :recipe="currentRecipeForReview"
            :gun-data="gunDataForCurrentRecipe"
            :total-number-of-recipes="updated_recipes.length"
            @validated="handleRecipeVisualization"
          />
          <div
            id="modal-form"
            ref="modal"
            class="modal fade"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-form"
            aria-hidden="true"
            style="z-index: 1050 !important"
          >
            <GunMultipleModal
              :key="selected_measurement !== null ? selected_measurement.id : ''"
              :gun-dataset="datapoints_gun_detail_modal"
              :gun-recipes="selected_measurement !== null ? Object.values(selected_measurement.recipes) : []"
              :hopper-name="selected_measurement !== null ? selected_measurement.hopper.name : ''"
              :created-at-timestamp="selected_measurement !== null ? selected_measurement.created_at : null"
              :show-modal-loading-spinner="show_modal_loading_spinner"
              @close="selected_measurement = null"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import setTooltip from "@/assets/js/tooltip.js";
import { autoFillInputColumn, numericPositiveOnly, roundPowderAmountParameters } from "@/views/composables.js";
import SoftButton from "@/components/SoftButton.vue";
import GunMultipleModal from "./components/GunMultipleModal.vue";
import SteelCaseGunsEqualizationChart from "./components/SteelCaseGunsEqualizationChart.vue";
import DiameterMeasurementGunReviewModal from "./components/DiameterMeasurementGunReviewModal.vue";
import RecipesReviewModal from "./components/RecipesReviewModal.vue";
import LineLayoutVisualization from "./components/LineLayoutVisualization.vue";
import HopperSelector from "./components/HopperSelector.vue";

export default {
  name: "DiameterMeasurement",
  components: {
    SoftButton,
    GunMultipleModal,
    SteelCaseGunsEqualizationChart,
    DiameterMeasurementGunReviewModal,
    RecipesReviewModal,
    LineLayoutVisualization,
    HopperSelector,
  },
  props: {
    lineId: {
      type: String,
      default: "",
    },
    diameterMeasurementId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      hoppers: [],
      line_id: null,
      coating_booth: null,
      selected_hopper: null,
      is_calculation_completed: false,
      showLineLayoutVisualization: false,
      gun_data: [],
      guns_equalization_datasets: [],
      updated_recipes: [],
      visualize_recipes: false,
      recipe_review_index: 0,
      lock_dropdown: false,
      gun_data_for_recipes: [],
      change_venturi_guns_evaluated: false,
      maintenance_needed_guns_evaluated: false,
      gun_review_index: 0,
      previous_measurements: [],
      selected_measurement: null,
      show_modal_loading_spinner: false,
      datapoints_gun_detail_modal: [],
      hovered_measurement: null,
      isMichiganRegionUser: null,
    };
  },
  computed: {
    venturiDiametersUpdated() {
      return (
        this.selected_hopper !== null &&
        !this.emptyVenturiDiametersMeasurements &&
        this.is_calculation_completed === true
      );
    },
    emptyVenturiDiametersMeasurements() {
      return this.gun_data.some(
        gun =>
          (gun.venturi_diameter === "" || gun.venturi_diameter == null) &&
          gun.current_gun_status.is_latest_bagging_valid !== false,
      );
    },
    gunsPendingToEvaluate() {
      if (!this.maintenance_needed_guns_evaluated) {
        return this.maintenanceNeededGunsPendingToEvaluate;
      } else if (!this.change_venturi_guns_evaluated) {
        return this.changeVenturiPendingToEvaluate;
      }
      return [];
    },
    maintenanceNeededGunsPendingToEvaluate() {
      if (!this.gun_data) {
        return [];
      }
      return this.gun_data.filter(
        gun => gun.validation_status === "failure" && gun.current_gun_status.is_latest_bagging_valid,
      );
    },
    changeVenturiPendingToEvaluate() {
      if (!this.gun_data) {
        return [];
      }
      return this.gun_data.filter(
        gun => gun.validation_status === "change venturi diameter" && gun.current_gun_status.is_latest_bagging_valid,
      );
    },
    gunsToRebag() {
      if (!this.gun_data) {
        return [];
      }
      return this.gun_data.filter(
        gun => gun.validation_status === "rebagging" && gun.current_gun_status.is_latest_bagging_valid,
      );
    },
    changeVenturiGunsToEvaluate() {
      if (!this.gun_data) {
        return [];
      }
      return this.gun_data.filter(
        gun =>
          ["change venturi diameter", "pending_change_venturi", "changing_venturi"].includes(gun.validation_status) &&
          gun.current_gun_status.is_latest_bagging_valid,
      );
    },
    failingGunsToEvaluate() {
      if (!this.gun_data) {
        return [];
      }
      return this.gun_data.filter(
        gun =>
          ["failure", "rejected", "rebagging"].includes(gun.validation_status) &&
          gun.current_gun_status.is_latest_bagging_valid,
      );
    },
    currentGunForReview() {
      if (this.failingGunsToEvaluate.length > 0 && !this.maintenance_needed_guns_evaluated) {
        return this.failingGunsToEvaluate[this.gun_review_index];
      } else if (this.changeVenturiGunsToEvaluate.length > 0 && !this.change_venturi_guns_evaluated) {
        return this.changeVenturiGunsToEvaluate[this.gun_review_index];
      }
      return {
        gun_name: null,
        validation_status: null,
        gun_index: null,
      };
    },
    totalNumberOfGunsToEvaluate() {
      if (this.failingGunsToEvaluate.length > 0 && !this.maintenance_needed_guns_evaluated) {
        return this.failingGunsToEvaluate.length;
      } else if (this.changeVenturiGunsToEvaluate.length > 0 && !this.change_venturi_guns_evaluated) {
        return this.changeVenturiGunsToEvaluate.length;
      }
      return 0;
    },
    currentRecipeForReview() {
      if (this.updated_recipes.length > 0) {
        return this.updated_recipes[this.recipe_review_index];
      }
      return null;
    },
    gunDataForCurrentRecipe() {
      if (this.gun_data_for_recipes.length > 0) {
        return this.gun_data_for_recipes.find(recipe => recipe.recipe_id == this.currentRecipeForReview.id);
      }
      return null;
    },
    allGunsEvaluated() {
      const all_guns_evaluated =
        this.maintenance_needed_guns_evaluated &&
        this.change_venturi_guns_evaluated &&
        !this.gun_data.some(gun => gun.validation_status === "changing_venturi") &&
        this.gunsToRebag.length == 0;

      if (all_guns_evaluated) {
        this.whenAllGunsEvaluated();
      }

      return all_guns_evaluated;
    },
    diametersUpdatedConfirmButtonText() {
      if (this.isMichiganRegionUser == true) {
        return "Save Venturi Diameters";
      } else if (this.gun_data.every(gun => gun.recipes.length == 0) && this.$route.query.fromBagging !== "true") {
        return "Save Venturi Diameters";
      } else if (this.$route.query.fromBagging == "true") {
        return "Update Recipes of all Hoppers";
      }
      return "Update Recipes of selected Hopper";
    },
  },
  mounted() {
    this.$store.state.isAbsolute = true;
    this.isMichiganRegionUser = this.$store.state.user_data.steelcase_service_region === "MICHIGAN";

    setTooltip();
    this.getData();
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
  },
  methods: {
    autoFillInputColumn,
    numericPositiveOnly,
    roundPowderAmountParameters,
    async getData() {
      if (this.line_id == null) {
        this.line_id = this.lineId;
      }

      await this.getBoothLines();
      await this.getHoppers();
      this.gun_data = await this.getGunData();

      if (this.gun_data.length > 0) {
        this.gun_data.sort((a, b) => a.gun_index - b.gun_index);
      }

      if (this.$route.query.fromBagging == "true") {
        await this.populateWithVenturiDiametersFromLastBagging();
      } else if (this.diameterMeasurementId != "") {
        this.getDiameterMeasurementData();
      }

      if (this.selected_hopper !== null) {
        this.showLineLayoutVisualization = true;
      }
      await this.fetchPreviousMeasurements();
    },
    async getBoothLines() {
      console.log("getBoothLines()");
      try {
        const response = await axios.get(`api/v1/steelcase/coatingbooth/${this.lineId}/`);
        this.coating_booth = response.data;
        this.reciprocator_side_A = this.coating_booth.reciprocator_side_A;
        this.reciprocator_side_B = this.coating_booth.reciprocator_side_B;
      } catch (error) {
        console.error(error);
      }
    },
    updateSelectedHopper(hopper) {
      this.selected_hopper = hopper;
      this.handleHopperSelection();
    },
    async handleHopperSelection() {
      this.showLineLayoutVisualization = true;
      await this.saveFormProgress();
    },
    generateGuns(total_guns) {
      return Array.from({ length: total_guns }, () => ({
        venturi_diameter: null,
      }));
    },
    async measureDiametersFinished() {
      console.log("measureDiametersFinished()");
      this.$store.state.isLoading = true;
      try {
        const response = await axios.get("api/v1/steelcase/coatingbooth/");
        const coating_booths = response.data;

        const coatingBoothWithPendingDiameterUpdate = coating_booths.find(
          coating_booth => coating_booth.pending_diameter_update === true,
        );

        if (coatingBoothWithPendingDiameterUpdate) {
          const response = await axios.post("/api/v1/steelcase/tempventuridiametermeasurement/", {});
          const diameterMeasurementId = response.data.id;

          await this.$router.push({
            name: "DiameterMeasurement",
            params: {
              lineId: coatingBoothWithPendingDiameterUpdate.id,
              diameterMeasurementId: diameterMeasurementId,
            },
            query: { fromBagging: "true" },
          });

          this.line_id = coatingBoothWithPendingDiameterUpdate.id;
          await this.clearDataVariables();

          await this.getData();
          await this.$swal({
            title: `Pending Diameter Measures Update for Line ${this.coating_booth.name}.`,
            text: "Please confirm Venturi Diameters below or edit them to update Recipes accordingly.",
            icon: "info",
            confirmButtonText: "OK",
          });
        } else {
          this.$router.push({
            name: "SteelCase",
          });
        }
      } catch (error) {
        console.error("Error fetching coating booths:", error);
      }
    },
    async clearDataVariables() {
      console.log("clearDataVariables()");
      this.hoppers = [];
      this.selected_hopper = null;
      this.dropdownVisible = false;
      this.searchQuery = "";
      this.is_calculation_completed = false;
      this.showLineLayoutVisualization = false;
      this.gun_data = [];
      this.guns_equalization_datasets = [];
      this.updated_recipes = [];
      this.visualize_recipes = false;
      this.recipe_review_index = 0;
      this.lock_dropdown = false;
      this.maintenance_needed_guns_evaluated = false;
      this.change_venturi_guns_evaluated = false;
    },
    async populateWithVenturiDiametersFromLastBagging() {
      try {
        const response = await axios.get(`api/v1/steelcase/venturidiametersfromlastbagging/${this.coating_booth.id}/`);
        if (response.data.hopper_id !== null) {
          this.updateSelectedHopper(this.hoppers.find(hopper => hopper.id == response.data.hopper_id));
        }
        if (response.data.venturi_diameters_by_gun_id) {
          this.gun_data = this.gun_data.map(gun => {
            const venturi_diameter = response.data.venturi_diameters_by_gun_id[gun.gun_id];
            return venturi_diameter ? { ...gun, venturi_diameter: venturi_diameter } : gun;
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    populateWithLastVenturiDiameters() {
      try {
        axios.get(`api/v1/steelcase/getlatestventuridiameters/${this.selected_hopper.id}/`).then(response => {
          if (response.data.venturi_diameters_by_gun_id) {
            this.gun_data = this.gun_data.map(gun => {
              const updated_gun = response.data.venturi_diameters_by_gun_id[gun.gun_id];
              return updated_gun ? { ...gun, venturi_diameter: updated_gun } : gun;
            });
            this.saveFormProgress();
          }
        });
      } catch (error) {
        console.error(error);
        this.$swal({
          title: "Error",
          text: `An error occurred while populating with last venturi diameters:\n${error.response.data.error}`,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    },
    clearVenturiDiameters() {
      this.gun_data.forEach(gun => {
        gun.venturi_diameter = null;
      });
      this.saveFormProgress();
    },
    async getResultsFromDiameterMeasurements() {
      console.log("getResultsFromDiameterMeasurements()");

      if (this.emptyVenturiDiametersMeasurements) {
        this.$swal({
          title: "Empty Measurements",
          text: "Please fill all the Diameter Measurement fields",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      try {
        this.$store.state.isLoading = true;

        if (this.isMichiganRegionUser == true) {
          // get coefficientts from latest bagging
          this.maintenance_needed_guns_evaluated = true;
          this.change_venturi_guns_evaluated = true;
          this.is_calculation_completed = true;
          this.$store.state.isLoading = false;
          return;
        }

        const float_venturi_diameters = this.gun_data.map(gun => {
          if (!gun.current_gun_status.is_latest_bagging_valid) {
            return null;
          }
          return parseFloat(gun.venturi_diameter);
        });

        const response = await axios.post("api/v1/steelcase/getresultsfromdiametermeasurements/", {
          hopper_id: this.selected_hopper.id,
          venturi_diameters: float_venturi_diameters,
        });

        if (!this.lock_dropdown) {
          this.lock_dropdown = true;
        }
        const received_guns_coefficients = response.data.guns;
        this.mapGunsLogisticModels(received_guns_coefficients);
        await this.getGunsEqualizationData();

        const received_recipes = response.data.recipes;
        this.maintenance_needed_guns_evaluated = false;
        this.change_venturi_guns_evaluated = false;
        this.addRecipesToGunData(received_recipes);

        if (this.maintenanceNeededGunsPendingToEvaluate.length == 0) {
          this.maintenance_needed_guns_evaluated = true;
        }
        if (this.changeVenturiPendingToEvaluate.length == 0) {
          this.change_venturi_guns_evaluated = true;
        }

        this.$store.state.isLoading = false;
        if (this.maintenance_needed_guns_evaluated && this.change_venturi_guns_evaluated) {
          this.venturiDiametersUpdatedSwal();
        }
        this.is_calculation_completed = true;
      } catch (error) {
        console.error(error);
        this.lock_dropdown = false;
        this.$store.state.isLoading = false;
        this.$swal({
          title: "Error",
          text: `An error occurred while updating the venturi diameters:\n${error.message}`,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    },
    async updateVenturiDiameterMeasurements() {
      console.log("updateVenturiDiameterMeasurements()");

      const float_venturi_diameters = this.gun_data.map(gun => {
        if (!gun.current_gun_status.is_latest_bagging_valid) {
          return null;
        }
        return parseFloat(gun.venturi_diameter);
      });

      const response = await axios.post("api/v1/steelcase/venturi-diameter-measurement/", {
        hopper: this.selected_hopper.id,
        venturi_diameters: float_venturi_diameters,
      });

      if (this.isMichiganRegionUser) {
        this.hoppers
          .filter(hopper => hopper.id !== this.selected_hopper.id)
          .map(async hopper => {
            axios.post("api/v1/steelcase/venturi-diameter-measurement/", {
              hopper: hopper.id,
              venturi_diameters: float_venturi_diameters,
            });
          });
      }

      return response;
    },
    async whenAllGunsEvaluated() {
      console.log("whenAllGunsEvaluated()");

      const swal_result = await this.$swal({
        title: "All guns evaluated",
        text: "All guns have been reviewed and evaluated.",
        icon: "success",
        confirmButtonText: this.diametersUpdatedConfirmButtonText,
        cancelButtonText: "Cancel",
        customClass: {
          confirmButton: "btn btn-success w-40 px-1 m-2",
          cancelButton: "btn btn-secondary w-40 px-1 m-2",
        },
        reverseButtons: true,
        buttonsStyling: false,
        showCancelButton: true,
      });

      if (swal_result.isConfirmed) {
        try {
          this.$store.state.isLoading = true;

          // TEMPORARY HACK
          if (this.isMichiganRegionUser == false) {
            await this.updateSelectedHopperRecipes();
          }

          const reponse_update_venturi_diameter_measurements = await this.updateVenturiDiameterMeasurements();
          const venturi_diameter_measurement_id = reponse_update_venturi_diameter_measurements.data.id;

          await this.updatePendingDiameterUpdate();

          // TEMPORARY HACK
          if (this.isMichiganRegionUser == false) {
            await this.storeSelectedHopperInferredGunCoefficientsAndStatus(venturi_diameter_measurement_id);
            await this.updateOtherHopperRecipes();
          }
          this.$store.state.isLoading = false;
        } catch (error) {
          console.error(error);
        }
      }
    },
    async updateSelectedHopperRecipes() {
      console.log("updateSelectedHopperRecipes()");
      if (this.gun_data[0].recipes.length == 0) {
        return;
      }
      try {
        // For the first gun, iterate over its recipes
        // for each recipe, create new the powder amount settings and diagnosis objects
        for (const [recipe_index, recipe] of this.gun_data[0].recipes.entries()) {
          const recipe_id = recipe.id;
          const update_data = this.gun_data.map(gun => ({
            gun_id: gun.gun_id,
            powder_amount_setting: gun.recipes.find(r => r.id === recipe_id).new_powder_amount_setting,
          }));

          const response = await axios.post("api/v1/steelcase/bulkupdatepowderamountsettingsperrecipe/", {
            recipe_id: recipe_id,
            update_data: update_data,
          });

          const current_updated_recipe = response.data;
          current_updated_recipe["id"] = recipe_id;
          current_updated_recipe["recipe_index"] = recipe_index;
          this.updated_recipes.push(current_updated_recipe);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async updatePendingDiameterUpdate() {
      if (this.$route.query.fromBagging == "true") {
        await axios.patch("api/v1/steelcase/coatingbooth/" + this.coating_booth.id + "/", {
          pending_diameter_update: false,
        });
      }
    },
    async updateOtherHopperRecipes() {
      console.log("updateOtherHopperRecipes()");
      try {
        if (this.$route.query.fromBagging !== "true" && !this.isMichiganRegionUser) {
          return;
        }

        // If there are no other hoppers, we don't need to update anything
        const hoppers_to_update = this.hoppers.filter(
          hopper => hopper.id !== this.selected_hopper.id && hopper.total_number_of_recipes > 0,
        );
        if (hoppers_to_update.length == 0) {
          return;
        }

        const hoppers_to_update_ids = hoppers_to_update.map(hopper => hopper.id);
        let updated_hoppers_response = null;
        try {
          updated_hoppers_response = await axios.post("api/v1/steelcase/bulkupdaterecipesformultiplehoppers/", {
            hopper_ids: hoppers_to_update_ids,
          });
        } catch {
          if (updated_hoppers_response == null || updated_hoppers_response.status === 500)
            this.$swal({
              title: `Error updating other Hopper's Recipes: ${hoppers_to_update.map(h => h.name).join(", ")}`,
              text: "Some powder amount setting are not computable using the trained model. You may update the recipes manually or redo the bagging.",
              icon: "error",
              confirmButtonText: "OK",
            });
        }

        const updated_recipes_by_hopper = updated_hoppers_response.data.updated_recipes_by_hopper;
        const inference_outputs_by_hopper = updated_hoppers_response.data.inference_outputs_by_hopper;

        hoppers_to_update.forEach(async hopper => {
          const inference_outputs = inference_outputs_by_hopper[hopper.id];
          if (inference_outputs == undefined || inference_outputs == null) {
            this.$swal({
              title: `Could not update ${hopper.name} recipes`,
              text: `The ${hopper.name} does not have any Venturi Diameters defined, therefore its recipes could not be updated. Perform at least one bagging or one Measure Diameter process if you want this hopper recipes to be updated.`,
              icon: "error",
              confirmButtonText: "OK",
            });
            return;
          }

          const diagnosis_per_recipe = Object.entries(inference_outputs.recipes).reduce((acc, [recipe_id, data]) => {
            const filtered_gun_info = Object.entries(data.gun_info).reduce((acc, [gun_id, gun_data]) => {
              acc[gun_id] = gun_data.diagnosis;
              return acc;
            }, {});
            acc[recipe_id] = filtered_gun_info;
            return acc;
          }, {});

          await this.storeInferredGunCoefficientsAndStatus(
            hopper.id,
            inference_outputs.gun_output_data,
            diagnosis_per_recipe,
          );
        });

        let recipeIndex = this.updated_recipes.length;
        for (const [, recipes] of Object.entries(updated_recipes_by_hopper)) {
          recipes.forEach(recipe => {
            const current_updated_recipe = recipe.prev_current_pas_per_gun;
            current_updated_recipe["id"] = String(recipe.recipe_id);
            current_updated_recipe["recipe_index"] = recipeIndex;
            this.updated_recipes.push(current_updated_recipe);
            recipeIndex++;
          });
        }
        for (const recipe of this.updated_recipes) {
          let recipe_response = await axios.get("api/v1/steelcase/recipe/" + recipe.id + "/");
          let hopper_response = await axios.get("api/v1/steelcase/hopper/" + recipe_response.data.hopper.id + "/");
          this.gun_data_for_recipes.push({
            recipe_id: recipe.id,
            recipe_name: recipe_response.data.category || "unknown",
            hopper_name: hopper_response.data.name || "unknown",
            line_name: this.coating_booth.name || "unknown",
            gun_data: await this.getGunDataForRecipe(recipe),
          });
        }
        this.visualize_recipes = true;
      } catch (error) {
        console.error(error);
      }
    },
    async storeSelectedHopperInferredGunCoefficientsAndStatus(venturi_diameter_measurement_id = null) {
      console.log("storeSelectedHopperInferredGunCoefficientsAndStatus()");

      // Gets the input data to store the inferred data for the current selected hopper
      const guns = this.gun_data.reduce((acc, item) => {
        acc[item.gun_identifier] = {
          venturi_diameter: item.venturi_diameter,
          coefficients: {
            L: item.L,
            k: item.k,
            x0: item.x0,
          },
        };
        return acc;
      }, {});

      const diagnosis_per_recipe = this.updated_recipes.reduce((result_dict, item) => {
        result_dict[item.id] = this.gun_data.reduce((acc, gun) => {
          const recipe = gun.recipes.find(r => r.id === item.id);
          if (recipe) {
            acc[gun.gun_identifier] = recipe.diagnosis;
          }
          return acc;
        }, {});
        return result_dict;
      }, {});

      await this.storeInferredGunCoefficientsAndStatus(
        this.selected_hopper.id,
        guns,
        diagnosis_per_recipe,
        venturi_diameter_measurement_id,
      );
    },
    async storeInferredGunCoefficientsAndStatus(
      hopper_id,
      gun_output_data,
      diagnosis_per_recipe,
      venturi_diameter_measurement_id = null,
    ) {
      console.log("storeInferredGunCoefficientsAndStatus()");

      await axios.post("api/v1/steelcase/bulkupdateinferredcoefficientsandstatus/", {
        hopper_id: hopper_id,
        gun_output_data: gun_output_data,
        diagnosis_per_recipe: diagnosis_per_recipe,
        venturi_diameter_measurement_id: venturi_diameter_measurement_id,
      });
    },
    addRecipesToGunData(received_data) {
      console.log("addRecipesToGunData()");

      this.gun_data = this.gun_data.map(gun => {
        if (Object.keys(received_data).length == 0) {
          return { ...gun, recipes: [] };
        }
        if (!["valid", "rejected", "pending_change_venturi"].includes(gun.validation_status)) {
          const gun_recipes = Object.entries(received_data).map(([key, recipe]) => ({
            id: key,
            category: recipe.category,
            target_throughput: recipe.target_throughput,
            target_throughput_bottom: recipe.target_throughput_bottom,
            new_powder_amount_setting: recipe.gun_info[gun.gun_identifier].new_powder_amount_setting,
            real_throughput: recipe.gun_info[gun.gun_identifier].real_throughput,
            diagnosis: recipe.gun_info[gun.gun_identifier].diagnosis,
          }));
          const allRecipesValid = gun_recipes.some(recipe => recipe.diagnosis === "failure")
            ? "failure"
            : gun_recipes.some(recipe => recipe.diagnosis === "change venturi diameter")
              ? "change venturi diameter"
              : "valid";
          return {
            ...gun,
            recipes: gun_recipes,
            validation_status: allRecipesValid,
          };
        }
        return gun;
      });
    },
    mapGunsLogisticModels(data) {
      console.log("mapGunsLogisticModels()");

      this.gun_data = this.gun_data.map(gun => {
        if (
          !["valid", "rejected", "pending_change_venturi", "rebagging"].includes(gun.validation_status) &&
          gun.current_gun_status.is_latest_bagging_valid
        ) {
          const coeffs = data[gun.gun_identifier].coefficients;

          return coeffs
            ? {
                ...gun,
                L: coeffs.L,
                k: coeffs.k,
                x0: coeffs.x0,
              }
            : gun;
        }
        return gun;
      });
    },
    async getDiameterMeasurementData() {
      console.log("getDiameterMeasurementData()");

      try {
        const response = await axios.get(
          "api/v1/steelcase/tempventuridiametermeasurement/" + this.$route.params.diameterMeasurementId,
        );

        if (response.data.hopper_id !== null) {
          this.updateSelectedHopper(this.hoppers.find(hopper => hopper.id == response.data.hopper_id));
        }
        if (response.data.venturi_diameters) {
          this.gun_data = this.gun_data.map(gun => {
            const updated_gun = response.data.venturi_diameters.find(
              venturi_data => venturi_data.gun_index === gun.gun_index,
            );
            return updated_gun ? { ...gun, venturi_diameter: updated_gun.venturi_diameter } : gun;
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    async redirectToReBagging() {
      console.log("redirectToReBagging()");

      try {
        await this.updateLatestGunModelCoefficientsFittedAsRebagged();
        const response = await axios.post("/api/v1/steelcase/temppowderoutputmeasurement/", {});
        const newPowderOutputMeasurementId = response.data.id;
        const rebaggingEditableGunIds = this.gunsToRebag.map(gun => gun.gun_id);
        this.$router.push({
          name: "Bagging",
          params: {
            lineId: this.lineId,
            powderOutputMeasurementId: newPowderOutputMeasurementId,
            populateWithLatestBaggingMeasures: true,
            rebaggingEditableGuns: rebaggingEditableGunIds,
          },
        });
      } catch (error) {
        console.error(error);
      }
    },
    async saveFormProgress() {
      console.log("saveFormProgress()");

      if (!this.diameterMeasurementId) {
        return;
      }

      try {
        const venturi_diameters_measurements = this.gun_data.map(gun => ({
          gun_index: gun.gun_index,
          venturi_diameter: gun.venturi_diameter,
        }));
        const dataForm = {
          hopper_id: this.selected_hopper !== null ? this.selected_hopper.id : null,
          venturi_diameters: venturi_diameters_measurements,
        };

        await axios.patch(
          `/api/v1/steelcase/tempventuridiametermeasurement/` + this.diameterMeasurementId + `/`,
          dataForm,
        );
      } catch (error) {
        console.error("Error saving form progress:", error);
      }
    },
    venturiDiametersUpdatedSwal() {
      try {
        this.$swal({
          title: "Venturi diameters updated",
          text: "Recipes adjustment calculation successful",
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (error) {
        console.error(error);
      }
    },
    async getHoppers() {
      if (this.coating_booth.id === null) {
        return;
      }
      try {
        let response = await axios.get("api/v1/steelcase/hopper/coating-booth/" + this.coating_booth.id + "/");
        this.hoppers = response.data;
        if (this.isMichiganRegionUser) {
          this.updateSelectedHopper(this.hoppers[0]);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getGunData() {
      console.log("getGunData()");

      try {
        const response = await axios.get(`api/v1/steelcase/guns/coating-booth/${this.coating_booth.id}/`);
        const gun_data_response = response.data;
        return gun_data_response.map(gun => ({
          gun_id: gun.id,
          gun_index: gun.gun_index,
          gun_identifier: gun.gun_identifier,
          gun_name: gun.name,
          current_gun_status: gun.current_gun_status,
          venturi_diameter: null,
          L: null,
          k: null,
          x0: null,
          validation_status: null,
          recipes: null,
        }));
      } catch (error) {
        console.error(error);
        return [];
      }
    },
    async getGunsEqualizationData() {
      try {
        const guns_logistic_data = this.gun_data.reduce((acc, gun) => {
          if (gun.current_gun_status.is_latest_bagging_valid) {
            acc[gun.gun_name] = {
              L: gun.L,
              k: gun.k,
              x0: gun.x0,
            };
          }
          return acc;
        }, {});
        const body = {
          coating_booth_id: this.coating_booth.id,
          data: guns_logistic_data,
        };
        const response = await axios.post("api/v1/steelcase/computelogisticdiagrampergun/", body);
        this.guns_equalization_datasets = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    nextGunReview() {
      console.log("nextGunReview()");
      if (this.gun_review_index < this.totalNumberOfGunsToEvaluate - 1) {
        this.gun_review_index++;
      }
    },
    previousGunReview() {
      console.log("previousGunReview()");
      if (this.gun_review_index > 0) {
        this.gun_review_index--;
      }
    },
    doneReviewingFailedGuns() {
      console.log("doneReviewingFailedGuns()");

      this.maintenance_needed_guns_evaluated = true;

      if (this.changeVenturiPendingToEvaluate.length == 0) {
        this.change_venturi_guns_evaluated = true;
      }

      this.gun_review_index = 0;
      if (this.gunsToRebag.length > 0) {
        this.redirectToReBagging();
      }
    },
    doneReviewingChangeVenturiGuns() {
      console.log("doneReviewingChangeVenturiGuns()");

      this.change_venturi_guns_evaluated = true;
      this.gun_review_index = 0;
    },
    async updateLatestGunModelCoefficientsFittedAsRebagged() {
      console.log("updateLatestGunModelCoefficientsFittedAsRebagged()");

      for (const gun of this.gun_data) {
        if (gun.validation_status == "rebagging") {
          try {
            await axios.post("api/v1/steelcase/updatelatestgunmodelcoefficientsfittedasrebagged/", {
              gun_id: gun.gun_id,
              hopper_id: this.selected_hopper.id,
            });
          } catch (error) {
            console.error("Error updating gun model as Rebagged. Error:", error);
          }
        }
      }
    },
    handleRecipeVisualization({ status }) {
      switch (status) {
        case "go_back":
          this.visualize_recipes = false;
          this.recipe_review_index = 0;
          break;
        case "next":
          if (this.recipe_review_index < this.updated_recipes.length - 1) {
            this.recipe_review_index++;
          } else {
            this.visualize_recipes = false;
            this.recipe_review_index = 0;
          }
          break;
        case "previous":
          if (this.recipe_review_index > 0) {
            this.recipe_review_index--;
          }
          break;
      }
    },
    getGunRegressionDataset(gun_name) {
      return this.guns_equalization_datasets.find(dataset => dataset.label === gun_name);
    },
    getGunRecipes(gun) {
      if (!gun.recipes) {
        return null;
      }
      return gun.recipes.filter(recipe => recipe.real_throughput !== recipe.target_throughput);
    },
    async getGunDataForRecipe(current_recipe) {
      try {
        const gun_diagnosis_response = await axios.get(
          `api/v1/steelcase/getlastguninferredstatusforrecipe/coating-booth/${this.coating_booth.id}/recipe/${current_recipe.id}/`,
        );
        const diagnosis_by_gun_id = gun_diagnosis_response.data.diagnosis_by_gun_id;

        return this.gun_data.map(gun => {
          const recipeData = current_recipe.find(recipe_gun => recipe_gun.gun_id === gun.gun_id);
          const isValid = gun.current_gun_status.is_latest_bagging_valid;
          return {
            gun_index: gun.gun_index,
            gun_identifier: gun.gun_identifier,
            gun_name: gun.gun_name,
            validation_status: isValid ? diagnosis_by_gun_id[gun.gun_id] || "unknown" : "rejected",
            recipe_diagnosis: isValid ? diagnosis_by_gun_id[gun.gun_id] || "failure" : "failure",
            old_powder_amount_setting: recipeData.previous || null,
            new_powder_amount_setting: isValid ? recipeData.current || null : null,
          };
        });
      } catch (error) {
        console.error("Error fetching gun data for recipe:", error);
        return [];
      }
    },
    getValidationClass(gunIndex) {
      const gun = this.gun_data.find(gun => gun.gun_index === gunIndex);
      if (!gun.current_gun_status.is_latest_bagging_valid) {
        return "rejected-row";
      }
      if (!gun || !gun.validation_status) {
        return "";
      }
      switch (gun.validation_status) {
        case "valid":
          return "valid-row";
        case "changing_venturi":
          return "accepted-row";
        case "pending_change_venturi":
          return "accepted-row";
        case "rejected":
          return "rejected-row";
        default:
          return "";
      }
    },
    diameterWithinRangeCheck(target_value, gun) {
      target_value = this.formatDiameter(target_value);
      if (target_value != "" && (target_value < 5 || target_value > 10)) {
        this.$swal({
          title: "Invalid Diameter: " + target_value.toString() + "mm",
          text: "The diameter must be between 5 and 10 mm.",
          icon: "error",
          confirmButtonText: "OK",
        }).then(() => {
          gun.venturi_diameter = "";
          this.saveFormProgress();
        });
      } else {
        gun.venturi_diameter = target_value;
      }
    },
    formatDiameter(input) {
      const digitsOnly = input.toString().replace(/\D/g, "");

      if (!digitsOnly) return "";

      const formatted = digitsOnly.length === 1 ? digitsOnly : `${digitsOnly[0]}.${digitsOnly.slice(1)}`;

      return parseFloat(parseFloat(formatted).toFixed(2));
    },
    formatPreviousMeasurementsResponse(previous_measurements) {
      // Temporary hack
      console.log(this.gun_data);
      const formatterdMeasurements = [];

      for (const measurement of previous_measurements) {
        const gun_diameter_history = {};
        const hopperOfMeasurement = this.hoppers.find(h => String(h.id) == String(measurement.hopper));
        if (!hopperOfMeasurement) {
          continue;
        }
        for (const gun of this.gun_data) {
          gun_diameter_history[gun.gun_id] = {
            gun_index: gun.gun_index,
            gun_identifier: gun.gun_identifier,
            L: gun.L,
            k: gun.k,
            x0: gun.x0,
            venturi_diameter: measurement.venturi_diameters[gun.gun_index - 1],
          };
        }
        formatterdMeasurements.push({
          id: measurement.id,
          created_at: new Date(measurement.created_at).toLocaleString(),
          hopper: {
            id: measurement.hopper,
            name: hopperOfMeasurement.name,
          },
          inference: gun_diameter_history,
          recipes: {},
        });
      }
      return formatterdMeasurements;
    },
    async fetchPreviousMeasurements() {
      try {
        // TEMPORARY HACK HACK HACK:
        // Needed because the other endpoint doesnt return data if the inference objects dont exist
        if (this.isMichiganRegionUser == true) {
          const response = await axios.get(`/api/v1/steelcase/venturi-diameter-measurement/?ordering=-created_at'`);
          console.log("Previous measurements response:", response.data);
          //this.previous_measurements = response.data;
          this.previous_measurements = this.formatPreviousMeasurementsResponse(response.data);
          console.log("Previous measurements response FIXED:", this.previous_measurements);
          return;
        }

        const response = await axios.get(`/api/v1/steelcase/previous-diameter-measurements/${this.coating_booth.id}/`);
        console.log("Previous measurements response OG:", response.data);
        this.previous_measurements = response.data;
      } catch (error) {
        console.error("Error fetching previous measurements:", error);
      }
    },
    getVenturiColorFromDiameter(venturi_diameter) {
      const minValue = 6.0;
      const maxValue = 8.5;
      const diameter = parseFloat(venturi_diameter);
      if (isNaN(diameter)) return "rgb(191, 191, 191)"; // Gray for invalid input

      const colorStops = [
        { r: 35, g: 235, b: 122 }, // Green
        { r: 255, g: 255, b: 191 }, // Yellow
        { r: 242, g: 83, b: 75 }, // Red
      ];

      let t;
      if (diameter <= minValue) {
        t = 0;
      } else if (diameter >= maxValue) {
        t = 1;
      } else {
        t = (diameter - minValue) / (maxValue - minValue); // Normalize to [0, 1]
      }

      function interpolateColor(t) {
        let start, end;
        if (t <= 0.5) {
          start = colorStops[0];
          end = colorStops[1];
          t = t / 0.5;
        } else {
          start = colorStops[1];
          end = colorStops[2];
          t = (t - 0.5) / 0.5;
        }

        const r = Math.round(start.r + (end.r - start.r) * t);
        const g = Math.round(start.g + (end.g - start.g) * t);
        const b = Math.round(start.b + (end.b - start.b) * t);
        return `rgb(${r}, ${g}, ${b})`;
      }

      return interpolateColor(t);
    },
    async showGunDetailModal(measurement) {
      // TEMPORARY HACK
      if (this.isMichiganRegionUser == true) {
        return;
      }
      this.show_modal_loading_spinner = true;
      this.selected_measurement = measurement;

      const logistic_diagram_request_body = Object.entries(measurement.inference).reduce((acc, [gun_id, gun]) => {
        const current_gun_data = this.gun_data.find(g => g.gun_id == gun_id);
        if (current_gun_data) {
          acc[current_gun_data.gun_name] = {
            L: gun.L,
            k: gun.k,
            x0: gun.x0,
          };
        }
        return acc;
      }, {});

      let response_datapoints = await axios.post("api/v1/steelcase/computelogisticdiagrampergun/", {
        coating_booth_id: this.coating_booth.id,
        data: logistic_diagram_request_body,
      });

      this.datapoints_gun_detail_modal = response_datapoints.data;
      this.show_modal_loading_spinner = false;
    },
  },
};
</script>
<style scoped>
.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.container-fluid {
  padding-top: 20px;
}

.valid-row {
  background-color: #d4edda !important;
  /* green */
}

.accepted-row {
  background-color: #fff3cd !important;
  /* yellow */
}

.rejected-row {
  background-color: #f8d7da !important;
  /* red */
}

.hovered-row {
  background-color: #f5f5f7 !important;
  /* gray */
  font-weight: bold;
}

.color-legend {
  display: flex;
  gap: 15px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  font-size: 0.9rem;
}

.legend-item {
  display: flex;
  align-items: center;
}

.color-box {
  width: 20px;
  height: 20px;
  display: inline-block;
  border-radius: 3px;
  margin-right: 6px;
  border: 1px solid #ccc;
}
</style>
